import { __makeTemplateObject } from "tslib";
import { MdClose } from 'react-icons/md';
import React from 'react';
import IconButton from '../IconButton';
import Icon from '../Icon';
import styled from 'styled-components';
var StyledIconButton = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: currentColor;\n  position: absolute !important;\n  top: 0;\n  right: 0;\n\n  :hover {\n    background: red;\n    color: white;\n    transition: color 300ms;\n    transition: background 300ms;\n  }\n"], ["\n  color: currentColor;\n  position: absolute !important;\n  top: 0;\n  right: 0;\n\n  :hover {\n    background: red;\n    color: white;\n    transition: color 300ms;\n    transition: background 300ms;\n  }\n"])));
export default function CloseIcon(props) {
    return (React.createElement(StyledIconButton, { onClick: props.onClick, dense: true },
        React.createElement(Icon, null,
            React.createElement(MdClose, null))));
}
var templateObject_1;
//# sourceMappingURL=CloseIcon.js.map